Coloradical = {
	Utils: {}
};

$(document).ready(function($){




	// ----------------------------------------------------------------------------
	//
	//	Check URL Contains
	//
	// ----------------------------------------------------------------------------

	if (/\/collections\/*|\/products\//.test(window.location.pathname)) $('#top a[href="/collections/all"]').addClass('current');
	if (/\/cart\/*/.test(window.location.pathname)) $('#top a[href="/cart"]').addClass('current');




	// ----------------------------------------------------------------------------
	//
	//	New logo to display in header
	//
	// ----------------------------------------------------------------------------

	// Ensure a new background everytime, sequentially

	var logo_index = parseInt($.cookie('logo_index')),
			settings = {"promo_message":"","blog_blurb":"Bloggin' and talkin' about new stuff, recent adventures, and good times. Thanks for tuning in.","checkout_header_image":"","checkout_logo_image":"","checkout_logo_position":"left","checkout_logo_size":"medium","checkout_body_background_image":"","checkout_body_background_color":"#fff","checkout_input_background_color_mode":"white","checkout_sidebar_background_image":"","checkout_sidebar_background_color":"#fafafa","checkout_heading_font":"Helvetica Neue","checkout_body_font":"Helvetica Neue","checkout_accent_color":"#2a9dcc","checkout_button_color":"#2a9dcc","checkout_error_color":"#ff6d6d","checkout_use_header_image":false,"checkout_logo":"","checkout_use_body_background_image":false,"checkout_use_sidebar_background_image":false,"customer_layout":"theme","checkout_banner_background_color":"#fff","checkout_call_to_action_color":"#8fc243","logo1":"logo1.png","logo2":"logo2.png","logo3":"logo3.png","logo4":"logo4.png","logo5":"logo5.png","logo6":"logo6.png"},
			logos = [
				"//www.coloradical.com/cdn/shop/t/2/assets/logo1.png?v=102823414126719655891517080245",
				"//www.coloradical.com/cdn/shop/t/2/assets/logo2.png?v=106364255250680956841659897262",
				"//www.coloradical.com/cdn/shop/t/2/assets/logo3.png?v=134056914065403962271517082005",
				"//www.coloradical.com/cdn/shop/t/2/assets/logo4.png?v=45549249226256669091659896780",
				"//www.coloradical.com/cdn/shop/t/2/assets/logo5.png?v=114900581689210873211659900454",
				"//www.coloradical.com/cdn/shop/t/2/assets/logo6.png?v=6311139787541518921659898910"
			];

	if (isNaN(logo_index)) logo_index = -1;

	if (logo_index + 1 <= 5) {
	  logo_index++;
	} else {
	  logo_index = 0
	}

	$.cookie('logo_index', logo_index, {path: '/'});

	$('.logo a').html('<img src="' + logos[logo_index] + '" width="260" height="122" alt="" style="display: none"/>');

	var $logo_img = $('.logo a img');

	if (!$logo_img.loaded) {
		$logo_img.one('load', function() {
			$logo_img.fadeIn('fast');
		});
	} else {
		$logo_img.fadeIn('fast');
	}




	// ----------------------------------------------------------------------------
	//
	//	Instayeah
	//
	// ----------------------------------------------------------------------------

	$.getJSON("https://api.instagram.com/v1/users/333953176/media/recent/?access_token=27966038.3346ba3.4dbb5fa813a64cea8d1b94b9cb1e2ec6&callback=?", function(d) {
		buildInstaPhoto(d);
	});

	function buildInstaPhoto(d) {
		var $insta_photo = $('.insta-photo');

		for (var i = 0; i < 2; i++) {
			var p = d.data[i],
					user = p.user.username,
					image_url = p.images.standard_resolution.url;

			$insta_photo.eq(i).append('<img src="'+ image_url +'" alt="" />');

			if (d.caption) {
				var new_caption = formatCaption(p);
				$('.insta-caption').eq(i).append('<p>'+ new_caption.text +'</p><a href="http://instagram.com/'+ user +'" target="_new">@'+ user +'</a>');
			} else {
				$('.insta-caption').eq(i).append('<a href="http://instagram.com/'+ user +'" target="_new">@'+ user +'</a>');
			}
		}
	};

	function formatCaption(p) {
		var text = p.caption.text;

		text = text.replace(/(^|\s)(#\w+)\b/g, '');

		return {
			'text': text
		}
	};




	// ----------------------------------------------------------------------------
	//
	//	Product Detail Thumbs / Feature Image Swaps
	//
	// ----------------------------------------------------------------------------

	var $placeholder = $('#placeholder'),
			$thumb = $('#product .thumb');

	$thumb.first().addClass('active');

	$placeholder.on('click', function(){
		return false;
	});

	$thumb.on('click', function(){
		var $t = $(this),
				$a = $('a', $t);

		$thumb.removeClass('active');
		$t.addClass('active');

		$placeholder.attr('href', $a.attr('href'));
		$('img', $placeholder).attr('src', $a.attr('data-original-image'));

		return false;
	});




	// ----------------------------------------------------------------------------
	//
	// Let's take a Field-trip
	//
	// ----------------------------------------------------------------------------

	if ($('#field-trips-page').length > 0) {
		var $field_trip_item = $('#field-trip-items li'),
				$field_trip_slides = $('#field-trip-slides'),
				$field_trip_select = $('#select-subnav select'),
				$preloader = $('#preloader'),
				$field_trip_spot = $('#field-trip-spot'),
				$prev_btn = $('#prev-btn'),
				$next_btn = $('#next-btn'),
				inmotion = false;
				g = 0;

		mockYeahIngYeahBirdYeah();
		fetchNewFieldTripData(g);

		$field_trip_spot.css('opacity','0');
		$field_trip_item.first().addClass('current');

		$field_trip_item.on('click', updateFieldTrip);
		$field_trip_select.on('change', function() {
			var select_index = $field_trip_select[0].selectedIndex;

			$field_trip_item.eq(select_index).trigger('click');
		});
	}

	function mockYeahIngYeahBirdYeah() {
		$.mockjax({
			url: '/mockyeah',
			contentType: "text/json",
			responseTime: 0,
			responseText: {
				galleries: [                    
                  {
						location: 'Umcompahgre',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/TLoSjY3.jpg" },
							{ image: "https://i.imgur.com/JU51XAY.jpg" },
							{ image: "https://i.imgur.com/n1CBTVJ.jpg" },
							{ image: "https://i.imgur.com/vtPZrIX.jpg" },
							{ image: "https://i.imgur.com/p74ecWT.jpg" },
							{ image: "https://i.imgur.com/yw4H36G.jpg" },
                            { image: "https://i.imgur.com/wnzO2oL.jpg" },
                          	{ image: "https://i.imgur.com/UesneKN.jpg" },
							{ image: "https://i.imgur.com/yNkD5K2.jpg" },
							{ image: "https://i.imgur.com/hYU7B3a.jpg" },
							{ image: "https://i.imgur.com/6w7Fqvc.jpg" },
                            { image: "https://i.imgur.com/D9kvrzY.jpg" },
                            { image: "https://i.imgur.com/4kFWOx4.jpg" }
						]
				  },
                  {
						location: 'Humboldt Peak',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/ZdAOj7o.jpg" },
							{ image: "https://i.imgur.com/BaIMWQX.jpg" },
							{ image: "https://i.imgur.com/NkfUHEr.jpg" },
							{ image: "https://i.imgur.com/kYZgtLe.jpg" },
							{ image: "https://i.imgur.com/PkCjzBm.jpg" },
							{ image: "https://i.imgur.com/mHeozxk.jpg" },
                            { image: "https://i.imgur.com/9PLvFzm.jpg" },
                          	{ image: "https://i.imgur.com/QNiKanP.jpg" },
							{ image: "https://i.imgur.com/81rzZTN.jpg" },
							{ image: "https://i.imgur.com/BkbP1ix.jpg" },
							{ image: "https://i.imgur.com/cDcugfl.jpg" },
                            { image: "https://i.imgur.com/yipWDJe.jpg" },
                            { image: "https://i.imgur.com/JA8KgzR.jpg" },
							{ image: "https://i.imgur.com/O8KzuMD.jpg" },
							{ image: "https://i.imgur.com/gnytwCW.jpg" }
						]
				  },
                  {
						location: 'Spring Daze',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/1DPKs5e.jpg" },
							{ image: "https://i.imgur.com/A8UZy6E.jpg" },
							{ image: "https://i.imgur.com/6rj0J0r.jpg" },
							{ image: "https://i.imgur.com/QqIk0L5.jpg" },
							{ image: "https://i.imgur.com/zkvEfht.jpg" },
							{ image: "https://i.imgur.com/g2HdM8r.jpg" },
                            { image: "https://i.imgur.com/QL1CqhD.jpg" },
                          	{ image: "https://i.imgur.com/xcDDEfi.jpg" },
							{ image: "https://i.imgur.com/cLP0ebY.jpg" },
							{ image: "https://i.imgur.com/dzQYRJ9.jpg" },
							{ image: "https://i.imgur.com/hNFUDSY.jpg" },
                            { image: "https://i.imgur.com/stSbqYc.jpg" },
                            { image: "https://i.imgur.com/TPsMPyU.jpg" },
							{ image: "https://i.imgur.com/QmLFL1v.jpg" },
							{ image: "https://i.imgur.com/9k1ZPOf.jpg" },
							{ image: "https://i.imgur.com/8DhC5hN.jpg" },
                            { image: "https://i.imgur.com/A3DPb2E.jpg" },
                            { image: "https://i.imgur.com/hmAFz1T.jpg" },
                            { image: "https://i.imgur.com/thrEjQO.jpg" }
						]
				  }, 
                  {
						location: 'Mount Sneffels',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/mbszxEf.jpg" },
							{ image: "https://i.imgur.com/mctMzBL.jpg" },
							{ image: "https://i.imgur.com/VDPMD0H.jpg" },
							{ image: "https://i.imgur.com/TMz4a10.jpg" },
							{ image: "https://i.imgur.com/lZ5DDf9.jpg" },
							{ image: "https://i.imgur.com/K9szNNy.jpg" },
                            { image: "https://i.imgur.com/k4458ZV.jpg" },
                          	{ image: "https://i.imgur.com/PkH2Wux.jpg" },
							{ image: "https://i.imgur.com/WaAEQqC.jpg" },
							{ image: "https://i.imgur.com/jDKddF4.jpg" },
							{ image: "https://i.imgur.com/yciHpUK.jpg" },
                            { image: "https://i.imgur.com/H8GhFJq.jpg" },
                            { image: "https://i.imgur.com/OfF6fzT.jpg" },
							{ image: "https://i.imgur.com/2VFSXu0.jpg" },
							{ image: "https://i.imgur.com/0bzvAkR.jpg" },
							{ image: "https://i.imgur.com/lg9UhwY.jpg" },
                            { image: "https://i.imgur.com/4rb7cj7.jpg" },
                            { image: "https://i.imgur.com/tpVrp1J.jpg" }
						]
				  }, 
                  {
						location: 'Knowles Canyon',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/lNW0yUo.jpg" },
							{ image: "https://i.imgur.com/6wtd222.jpg" },
							{ image: "https://i.imgur.com/Yd60NGW.jpg" },
							{ image: "https://i.imgur.com/FqyYeuy.jpg" },
							{ image: "https://i.imgur.com/sYxHZ8y.jpg" },
							{ image: "https://i.imgur.com/sCuSdpd.jpg" },
                            { image: "https://i.imgur.com/JDlHaKk.jpg" },
                          	{ image: "https://i.imgur.com/jIQfIDR.jpg" },
							{ image: "https://i.imgur.com/cgCDNBj.jpg" },
							{ image: "https://i.imgur.com/USNyxcm.jpg" },
							{ image: "https://i.imgur.com/h55nSzw.jpg" },
                            { image: "https://i.imgur.com/ibrRDtv.jpg" },
                            { image: "https://i.imgur.com/yLtSgOj.jpg" },
							{ image: "https://i.imgur.com/FLL52le.jpg" },
							{ image: "https://i.imgur.com/IJG3Ewq.jpg" },
							{ image: "https://i.imgur.com/pFDw9tp.jpg" },
                            { image: "https://i.imgur.com/z1qf0nG.jpg" },
                            { image: "https://i.imgur.com/fSPlI2x.jpg" }
						]
				  }, 
                  {
						location: 'Desert Drifter',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/DRXiUwS.jpg" },
							{ image: "https://i.imgur.com/2PwAYCx.jpg" },
							{ image: "https://i.imgur.com/FolCazp.jpg" },
							{ image: "https://i.imgur.com/lVyIWmP.jpg" },
							{ image: "https://i.imgur.com/Zpw6q5j.jpg" },
							{ image: "https://i.imgur.com/ftcq795.jpg" },
                            { image: "https://i.imgur.com/P9hVZsm.jpg" },
                          	{ image: "https://i.imgur.com/RYyHLWW.jpg" },
							{ image: "https://i.imgur.com/Fr5gFuu.jpg" },
							{ image: "https://i.imgur.com/H9HBIo9.jpg" },
							{ image: "https://i.imgur.com/RGyaxNr.jpg" },
                            { image: "https://i.imgur.com/SFnNybY.jpg" },
                            { image: "https://i.imgur.com/TKxUnPa.jpg" }
						]
				  }, 
                  {
						location: 'Aspen Ridge',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/AItCcT6.jpg" },
							{ image: "https://i.imgur.com/bn4AzWE.jpg" },
							{ image: "https://i.imgur.com/yarV1vC.jpg" },
							{ image: "https://i.imgur.com/RZZTKZf.jpg" },
							{ image: "https://i.imgur.com/Q6XUdaB.jpg" },
							{ image: "https://i.imgur.com/yPCT0Gm.jpg" },
                            { image: "https://i.imgur.com/LP4dLow.jpg" },
                          	{ image: "https://i.imgur.com/nh1lQ1F.jpg" },
							{ image: "https://i.imgur.com/oj42sq1.jpg" },
							{ image: "https://i.imgur.com/4teuoKG.jpg" },
							{ image: "https://i.imgur.com/Ct5XQAQ.jpg" },
                            { image: "https://i.imgur.com/TwDgXNE.jpg" },
                            { image: "https://i.imgur.com/jnkszzr.jpg" },
                            { image: "https://i.imgur.com/qhNyyhS.jpg" }
						]
				  },
                  {
						location: 'Mee Canyon',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/iTA24va.jpg" },
							{ image: "https://i.imgur.com/l5gqDQL.jpg" },
							{ image: "https://1.imgur.com/5qqnOVC.jpg" },
							{ image: "https://i.imgur.com/6WMIT7A.jpg" },
							{ image: "https://i.imgur.com/7u87Jcz.jpg" },
							{ image: "https://i.imgur.com/4jeGhEO.jpg" },
                            { image: "https://i.imgur.com/GOJLSP2.jpg" },
                          	{ image: "https://i.imgur.com/7YPV9sS.jpg" },
							{ image: "https://i.imgur.com/KnSWgwl.jpg" },
							{ image: "https://i.imgur.com/FIbaMEd.jpg" },
							{ image: "https://i.imgur.com/2Z3MZSZ.jpg" },
                            { image: "https://i.imgur.com/LenJYC0.jpg" },
                            { image: "https://i.imgur.com/4DI3XNV.jpg" }
						]
				  },
                  {
						location: 'Chicago Basin',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/GNR4fno.jpg" },
							{ image: "https://i.imgur.com/0Qnfe43.jpg" },
							{ image: "https://i.imgur.com/aMdGh7j.jpg" },
							{ image: "https://i.imgur.com/3M85IE9.jpg" },
							{ image: "https://i.imgur.com/RLyPymv.jpg" },
							{ image: "https://i.imgur.com/FjyksFA.jpg" },
                            { image: "https://i.imgur.com/pcU4Hth.jpg" },
                          	{ image: "https://i.imgur.com/WnkDJse.jpg" },
							{ image: "https://i.imgur.com/5jgu1ec.jpg" },
							{ image: "https://i.imgur.com/AY4uhuL.jpg" },
							{ image: "https://i.imgur.com/LdZq5Pz.jpg" },
                            { image: "https://i.imgur.com/17DvYLB.jpg" },
                            { image: "https://i.imgur.com/qGjaufx.jpg" },
                            { image: "https://i.imgur.com/k2tnZqB.jpg" },
							{ image: "https://i.imgur.com/qLDUh4O.jpg" },
                            { image: "https://i.imgur.com/j3MqgbZ.jpg" },
                            { image: "https://i.imgur.com/dLSW0qP.jpg" },
                            { image: "https://i.imgur.com/gznrSRA.jpg" }
						]
				  },
                  {
						location: 'Skeleton Gulch',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/cSLOHUf.jpg" },
							{ image: "https://i.imgur.com/CdvaOiC.jpg" },
							{ image: "https://i.imgur.com/d0BZtWc.jpg" },
							{ image: "https://i.imgur.com/IGixoWw.jpg" },
							{ image: "https://i.imgur.com/GCUjd4Y.jpg" },
							{ image: "https://i.imgur.com/MULemMJ.jpg" },
                            { image: "https://i.imgur.com/MQgNa25.jpg" },
                          	{ image: "https://i.imgur.com/XkRPaUy.jpg" },
							{ image: "https://i.imgur.com/r3TB8Vz.jpg" },
							{ image: "https://i.imgur.com/uXORHH3.jpg" },
							{ image: "https://i.imgur.com/FczLUOB.jpg" },
                            { image: "https://i.imgur.com/qfY78hx.jpg" },
                            { image: "https://i.imgur.com/Muxkstl.jpg" },
                            { image: "https://i.imgur.com/etKJDii.jpg" }
						]
				  },                         
                  {
						location: 'Holy Cross',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/yZlWadi.jpg" },
							{ image: "https://i.imgur.com/vb1Llhk.jpg" },
							{ image: "https://i.imgur.com/0drlK3i.jpg" },
							{ image: "https://i.imgur.com/FvhX5Fv.jpg" },
							{ image: "https://i.imgur.com/Qqtz9Z2.jpg" },
							{ image: "https://i.imgur.com/eiCVGz8.jpg" },
                            { image: "https://i.imgur.com/xqNLEFN.jpg" },
                          	{ image: "https://i.imgur.com/8mWeAq1.jpg" },
							{ image: "https://i.imgur.com/VACfcHm.jpg" },
							{ image: "https://i.imgur.com/uZKZ63l.jpg" },
							{ image: "https://i.imgur.com/DOEixvK.jpg" }
						]
				  },                         
                  {
						location: 'Kokopelli Trail',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/yLPf8Lo.jpg" },
							{ image: "https://i.imgur.com/L3zL43W.jpg" },
							{ image: "https://i.imgur.com/SM4S2f7.jpg" },
							{ image: "https://i.imgur.com/hK7BxGx.jpg" },
							{ image: "https://i.imgur.com/qVR8Fmw.jpg" },
							{ image: "https://i.imgur.com/d3VqOWi.jpg" },
                            { image: "https://i.imgur.com/OC0oJ9f.jpg" },
                          	{ image: "https://i.imgur.com/iEuA488.jpg" },
							{ image: "https://i.imgur.com/yD910xk.jpg" },
							{ image: "https://i.imgur.com/npuPGL0.jpg" },
							{ image: "https://i.imgur.com/yk0YbZB.jpg" },
							{ image: "https://i.imgur.com/19GSSJH.jpg" }
						]
				  },                
                  {
						location: 'Colorado Trail',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/341hGVX.jpg" },
							{ image: "https://i.imgur.com/fhTSEjT.jpg" },
							{ image: "https://i.imgur.com/9jHM4dm.jpg" },
							{ image: "https://i.imgur.com/aFN8kE7.jpg" },
							{ image: "https://i.imgur.com/x4ZK5lx.jpg" },
							{ image: "https://i.imgur.com/tJ9JmZf.jpg" },
                            { image: "https://i.imgur.com/NVWcTS5.jpg" },
                          	{ image: "https://i.imgur.com/5wmUMn3.jpg" },
							{ image: "https://i.imgur.com/VifCNmE.jpg" },
							{ image: "https://i.imgur.com/k3hKly7.jpg" },
							{ image: "https://i.imgur.com/te2T5b3.jpg" },
							{ image: "https://i.imgur.com/nlAS7dV.jpg" },
                          	{ image: "https://i.imgur.com/h64A6Pt.jpg" }
						]
				  },            		          
                  {
						location: 'Wetterhorn Peak',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/RqrXtrb.jpg" },
							{ image: "https://i.imgur.com/BaL1ipJ.jpg" },
							{ image: "https://i.imgur.com/zPtYiow.jpg" },
							{ image: "https://i.imgur.com/7Av7YZE.jpg" },
							{ image: "https://i.imgur.com/fLkAhcb.jpg" },
							{ image: "https://i.imgur.com/GiOp8jB.jpg" },
                          	{ image: "https://i.imgur.com/4onjsyv.jpg" },
							{ image: "https://i.imgur.com/5sKtXmx.jpg" },
							{ image: "https://i.imgur.com/uT30MrV.jpg" },
							{ image: "https://i.imgur.com/FqJg1Wb.jpg" },
							{ image: "https://i.imgur.com/Afj2sXO.jpg" },
							{ image: "https://i.imgur.com/i0Ca8nT.jpg" },
							{ image: "https://i.imgur.com/5ozaU7a.jpg" },
							{ image: "https://i.imgur.com/PkYuCy6.jpg" },
							{ image: "https://i.imgur.com/zt2HCUO.jpg" }
						]
				  },   
                  {
						location: 'Mt. Elbert',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/3fskfHC.jpg" },
							{ image: "https://i.imgur.com/Oe0pHJL.jpg" },
							{ image: "https://i.imgur.com/WVmcl8k.jpg" },
							{ image: "https://i.imgur.com/qeQcwsl.jpg" },
							{ image: "https://i.imgur.com/TV97M0W.jpg" },
							{ image: "https://i.imgur.com/RiKCUkY.jpg" },
							{ image: "https://i.imgur.com/MqVuuSb.jpg" },
							{ image: "https://i.imgur.com/FApRGLU.jpg" },
							{ image: "https://i.imgur.com/jio649s.jpg" }
						]
				  },   
                  {
						location: 'Mt. Massive',
						time: "",
						photos: [
							{ image: "https://i.imgur.com/kfxbPNS.jpg" },
							{ image: "https://i.imgur.com/fiTr7QL.jpg" },
							{ image: "https://i.imgur.com/oFA35GD.jpg" },
							{ image: "https://i.imgur.com/NshjZRq.jpg" },
							{ image: "https://i.imgur.com/UWaWek7.jpg" },
							{ image: "https://i.imgur.com/XD8sIR2.jpg" },
							{ image: "https://i.imgur.com/bGtaVRG.jpg" },
							{ image: "https://i.imgur.com/gzTRnJV.jpg" },
							{ image: "https://i.imgur.com/5Ht61ER.jpg" },
                          	{ image: "https://i.imgur.com/VYL9QpN.jpg" },
                            { image: "https://i.imgur.com/fcFlYqK.jpg" }
						]
				  },   
                  {
						location: 'Boulder Lake',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/E2Ch4L8.jpg" },
							{ image: "http://i.imgur.com/G6EznsL.jpg" },
							{ image: "http://i.imgur.com/hUbPBMn.jpg" },
							{ image: "http://i.imgur.com/5qSloUD.jpg" },
							{ image: "http://i.imgur.com/uRzKdKF.jpg" },
							{ image: "http://i.imgur.com/Ky6vMjB.jpg" },
							{ image: "http://i.imgur.com/dX6IRqW.jpg" },
							{ image: "http://i.imgur.com/F86mEmz.jpg" },
							{ image: "http://i.imgur.com/hwgQde4.jpg" },
                            { image: "http://i.imgur.com/fXK350y.jpg" }
						]
				  },   
                  {
						location: 'Lost Lake',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/XDvYO1e.jpg" },
							{ image: "http://i.imgur.com/wmVD1HI.jpg" },
							{ image: "http://i.imgur.com/DPRyXNt.jpg" },
							{ image: "http://i.imgur.com/t2fiPa2.jpg" },
							{ image: "http://i.imgur.com/qyj5LGJ.jpg" },
							{ image: "http://i.imgur.com/SG6n0Qv.jpg" },
							{ image: "http://i.imgur.com/6T7sQIP.jpg" },
							{ image: "http://i.imgur.com/dOi8cAL.jpg" },
							{ image: "http://i.imgur.com/EkHj2bB.jpg" },
                            { image: "http://i.imgur.com/1lQR7iX.jpg" }
						]
				  },      
                  {
						location: 'Big Dominguez',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/FjEnVAk.jpg" },
							{ image: "http://i.imgur.com/RNXQvgD.jpg" },
							{ image: "http://i.imgur.com/MCTeN20.jpg" },
							{ image: "http://i.imgur.com/kvyYSNY.jpg" },
							{ image: "http://i.imgur.com/qoN3Lm0.jpg" },
							{ image: "http://i.imgur.com/ymB4ikY.jpg" },
							{ image: "http://i.imgur.com/VhzWJcu.jpg" },
							{ image: "http://i.imgur.com/pAvTRxJ.jpg" },
							{ image: "http://i.imgur.com/NTP4ciG.jpg" },
                            { image: "http://i.imgur.com/0hq9awl.jpg" },
                            { image: "http://i.imgur.com/EHDYnUg.jpg" },
							{ image: "http://i.imgur.com/T5CqbFK.jpg" }
						]
				  },   
                  {
						location: 'Monument Trail',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/yjTcv2h.jpg" },
							{ image: "http://i.imgur.com/FQ5kskb.jpg" },
							{ image: "http://i.imgur.com/itIAXmY.jpg" },
							{ image: "http://i.imgur.com/WG5QPaK.jpg" },
							{ image: "http://i.imgur.com/G7R1Fle.jpg" },
							{ image: "http://i.imgur.com/QdtyauP.jpg" },
							{ image: "http://i.imgur.com/d4Xzcjf.jpg" },
							{ image: "http://i.imgur.com/nd3OuEZ.jpg" },
							{ image: "http://i.imgur.com/ySwurWB.jpg" },
							{ image: "http://i.imgur.com/wbi2Cb5.jpg" },
							{ image: "http://i.imgur.com/kewyxw6.jpg" }
						]
				  },               
					{
						location: 'Geneva Lake',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/redXgUJ.jpg" },
							{ image: "http://i.imgur.com/UV5SGAy.jpg" },
							{ image: "http://i.imgur.com/medXQ4o.jpg" },
							{ image: "http://i.imgur.com/59MmuC6.jpg" },
							{ image: "http://i.imgur.com/Lpq2ZUU.jpg" },
							{ image: "http://i.imgur.com/C7JpXrY.jpg" },
							{ image: "http://i.imgur.com/hTvyzck.jpg" },
							{ image: "http://i.imgur.com/ifw8jyO.jpg" },
							{ image: "http://i.imgur.com/sU9yU4e.jpg" },
							{ image: "http://i.imgur.com/sXB1hui.jpg" },
							{ image: "http://i.imgur.com/NT1aaL5.jpg" },
							{ image: "http://i.imgur.com/vtW8NkO.jpg" }
						]
                    },
					{
						location: 'Sand Dunes',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/rQxzfZF.jpg" },
							{ image: "http://i.imgur.com/i7yU7g1.jpg" },
							{ image: "http://i.imgur.com/oVrywyP.jpg" },
							{ image: "http://i.imgur.com/TNaknmo.jpg" },
							{ image: "http://i.imgur.com/fbhF3uN.jpg" },
							{ image: "http://i.imgur.com/xB5f3oK.jpg" },
							{ image: "http://i.imgur.com/UxoIGE6.jpg" },
							{ image: "http://i.imgur.com/3fcaei2.jpg" },
							{ image: "http://i.imgur.com/dIOeYVI.jpg" },
							{ image: "http://i.imgur.com/MvJR139.jpg" },
							{ image: "http://i.imgur.com/lJH4kth.jpg" },
							{ image: "http://i.imgur.com/NSWEJca.jpg" }
						]
					},
					{
						location: 'Conundrum',
						time: "",
						photos: [
							{ image: "http://i.imgur.com/dAmQ7gp.jpg" },
							{ image: "http://i.imgur.com/yGYdq9e.jpg" },
							{ image: "http://i.imgur.com/l1rzvSb.jpg" },
							{ image: "http://i.imgur.com/mISAsDt.jpg" },
							{ image: "http://i.imgur.com/Tuv0k9r.jpg" },
							{ image: "http://i.imgur.com/mQRzm22.jpg" },
							{ image: "http://i.imgur.com/4WVMYQ6.jpg" },
							{ image: "http://i.imgur.com/nlYTVQR.jpg" },
							{ image: "http://i.imgur.com/mFkYE9m.jpg" },
							{ image: "http://i.imgur.com/SfDLNUe.jpg" }
						]
					}
				]
			}
		});
	};

	function updateFieldTrip() {
		var $t = $(this),
				g = $t.index();

		if ($t.hasClass('current')) {
			return false;
		} else {
			$field_trip_item.off('click', updateFieldTrip);
			$prev_btn.off('click', previousSlide);
			$next_btn.off('click', nextSlide);

			$field_trip_item.removeClass('current');
			$t.addClass('current');

			$field_trip_select[0].selectedIndex = $('#field-trip-items li.current').index();

			transitionOut(g);
		}
	};

	function transitionOut(g) {
		$field_trip_spot.css('opacity','0');
		$prev_btn.css('margin-left','-60px');
		$next_btn.css('margin-right','-60px');

		$field_trip_slides.stop().animate({'top':'-100%'}, 666, 'easeInOutQuart', function() {
			$preloader.fadeIn(333, function() {
				$field_trip_slides.empty();
				fetchNewFieldTripData(g);
			});
		});
	};

	function fetchNewFieldTripData(g) {
		$.ajax({
			url: '/mockyeah',
			type: "GET",
			dataType: 'json',
			success: function(data) {
				var gallery = data.galleries[g];

				for (var i = 0; i < gallery.photos.length; i++) {
					var src = gallery.photos[i].image;

					$field_trip_slides.append('<li class="field-trip-slide"><img src="'+ src +'" alt="" /></li>');
				}

				setUpCurrentGallery(gallery);
				checkImagesLoaded();
			}
		});
	};

	function setUpCurrentGallery(gallery) {
		var $slide = $('.field-trip-slide', $field_trip_slides);

		$('#field-trip-location').text(gallery.location);
		$('#field-trip-time').text(gallery.time);

		$slide.removeClass('current').hide();
		$slide.first().addClass('current').show();
	};

	function checkImagesLoaded() {
		var $imgs = $('img', $field_trip_slides);
		Coloradical.Utils.loadingProgress($imgs, transitionIn, this);
	};

	function transitionIn() {
		setTimeout(function() {
			$preloader.fadeOut(333);
			$field_trip_slides.css('top','100%').stop().animate({'top':'0%'}, 666, 'easeInOutQuart', function() {
				$field_trip_select[0].selectedIndex = $('#field-trip-items li.current').index();
				$field_trip_item.on('click', updateFieldTrip);
				$prev_btn.on('click', previousSlide);
				$next_btn.on('click', nextSlide);
			});

			$field_trip_spot.css('opacity','1');
			$prev_btn.css('margin-left','0px');
			$next_btn.css('margin-right','0px');
		}, 666);
	};

	function previousSlide() {
		$prev_btn.off('click', previousSlide);
		$next_btn.off('click', nextSlide);

		var $current_slide = $('.field-trip-slide.current', $field_trip_slides),
				$prev_slide = $current_slide.prev().length ? $current_slide.prev() : $('.field-trip-slide', $field_trip_slides).last();

		$current_slide.removeClass('current').fadeOut(333, 'easeInOutQuart', function() {
			$prev_slide.addClass('current').fadeIn(333, function() {
				$prev_btn.on('click', previousSlide);
				$next_btn.on('click', nextSlide);
			});
		});
	};

	function nextSlide() {
		$prev_btn.off('click', previousSlide);
		$next_btn.off('click', nextSlide);

		var $current_slide = $('.field-trip-slide.current', $field_trip_slides),
				$next_slide = $current_slide.next().length ? $current_slide.next() : $('.field-trip-slide', $field_trip_slides).first();

		$current_slide.removeClass('current').fadeOut(333, 'easeInOutQuart', function() {
			$next_slide.addClass('current').fadeIn(333, function() {
				$prev_btn.on('click', previousSlide);
				$next_btn.on('click', nextSlide);
			});
		});
	};




	// ----------------------------------------------------------------------------
	//
	//	Check for iframe videos in the Blog and dynamically size them
	//
	// ----------------------------------------------------------------------------

	if ($('#blog-articles').length > 0) {
		checkForIframesAndResizeThem();
	}

	function checkForIframesAndResizeThem() {
		var $iframe = $('#blog-articles iframe');

		$iframe.each(function() {
			var $t = $(this),
					w = $t.attr('width'),
					h = $t.attr('height'),
					rat = (h / w) * 100;

			$t.wrap('<div class="iframe-holder" />');
			$t.parent('.iframe-holder').css('padding-bottom', rat + '%');
		});
	}

});
